import axiosInstance from "api/axiosInstance";

import type { InstructorScheduleListItem, InstructorScheduleDetail, InstructorScheduleCreateRequest, InstructorScheduleListParams } from "api/types/instructor-schedules.types";

const BASE = "/server/buccl_lessons/api/v1/instructor-schedules/";

export const instructorSchedulesService = {
  list: (params?: InstructorScheduleListParams) => axiosInstance.get<InstructorScheduleListItem[]>(BASE, { params }),

  get: (id: number) => axiosInstance.get<InstructorScheduleDetail>(`${BASE}${id}/`),

  create: (payload: InstructorScheduleCreateRequest) => axiosInstance.post<InstructorScheduleDetail>(BASE, payload),

  update: (id: number, payload: Partial<InstructorScheduleCreateRequest>) => axiosInstance.patch<InstructorScheduleDetail>(`${BASE}${id}/`, payload),

  reservations: (id: number) => axiosInstance.get(`${BASE}${id}/reservations/`),

  approve: (id: number) => axiosInstance.post(`${BASE}${id}/approve/`),

  reject: (id: number, reason?: string) => axiosInstance.post(`${BASE}${id}/reject/`, { reason }),

  pendingApprovals: () => axiosInstance.get<InstructorScheduleListItem[]>(`${BASE}pending-approvals/`),

  complete: (id: number) => axiosInstance.post(`${BASE}${id}/complete/`),
};
